import React from "react"
import { Container } from "reactstrap"

const Signout = () => {

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <h3>
          Signout
        </h3>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Signout